// STORYBOOK TOP LEVEL CATEGORIES
export const PAGES = 'Pages';
export const COMPLEX = 'Complex Components';
export const BASIC = 'Basic Components';
export const LAYOUTS = 'Page Layouts';
export const STYLEGUIDE = 'Styleguide';

// TODO: stories in this folder need to be:
//     1: updated to make sure there are no errors
//     2: updated to show all potential states
//     3: organized in a way that makes sense for a styleguide 
//          -separate out stories into atomic components - finish pages, show molecules/organisms, atoms
//          -group common stories together, like maybe all Media Library elements should be in one folder
//          -group unused components together, noting that they are old/unused
export const TBD = 'Not Yet Organized';


// STORYBOOK SUB-CATEGORIES
export const BUTTONS = 'Buttons';
export const FORMS = 'Form Elements';
export const PANELS = 'Panel Elements';
export const FLYOUT = 'Flyout Menu';
export const CONTENT_PAGE = 'Content Page';
export const DATA_PAGE = 'Data Page';
export const TABLES = 'Tables';


// COMMON STRINGS USED IN UI
export const PageTitleFragment = ' | Voter Mail';

// ERROR STATES
export const ERROR_ENUM = Object.freeze({ ERROR: 'ERROR', FIXED: 'FIXED' });